export const UPDATE_DOCTOR_DETAIL = "UPDATE_DOCTOR_DETAIL"
export const UPDATE_DOCTOR_DETAIL_FAIL = "UPDATE_DOCTOR_DETAIL_FAIL"
export const UPDATE_DOCTOR_DETAIL_SUCCESS = "UPDATE_DOCTOR_DETAIL_SUCCESS"
export const UPDATE_DOCTOR_DETAIL_RESET = "UPDATE_DOCTOR_DETAIL_RESET"

export const updateDoctorDetail = (params) => {
    return { type: UPDATE_DOCTOR_DETAIL, params }
}

export const updateDoctorDetailSuccess = (response) => {
    return { type: UPDATE_DOCTOR_DETAIL_SUCCESS, response }
}

export const updateDoctorDetailFail = (response) => {
    return { type: UPDATE_DOCTOR_DETAIL_FAIL, response }
}

export const updateDoctorDetailResetState = () => {
    return { type: UPDATE_DOCTOR_DETAIL_RESET }
}